import type { ReactNode } from 'react';
import { ENV_META, envFromApp } from '../lib/environments.js';
import { SEND_MODE_LABEL } from '../lib/labels.js';
import type { Me } from '../lib/session.js';
import { Badge } from './2b-status.js';
import '../screens-2b.css';

const MODE_TEXT: Record<Me['sendMode'], { tone: 'ok' | 'warn' | 'bad'; text: string }> = {
  dry_run: {
    tone: 'ok',
    text: 'Nic neodejde. Zprávy se jen vyhodnotí a zapíšou jako „nanečisto“.',
  },
  test_allowlist: {
    tone: 'warn',
    text: 'Zprávy odejdou jen na zkušební adresy z povoleného seznamu, nikdy zákazníkům.',
  },
  live: {
    tone: 'bad',
    text: 'POZOR: ostrý režim. Zprávy mohou odejít skutečným zákazníkům.',
  },
};

/**
 * Pruh „Kam se zpráva pošle“: prostředí, režim odesílání a co z toho plyne.
 * Patří na každou obrazovku, která může cokoli poslat nebo posunout čas.
 */
export function SendTarget({
  me,
  what,
  compact,
}: {
  me: Me;
  what?: ReactNode;
  compact?: boolean;
}): JSX.Element {
  const env = ENV_META[me.environment?.name ?? envFromApp(me.appEnv)];
  const mode = MODE_TEXT[me.sendMode];
  return (
    <div className={`s2b-target ${mode.tone}${compact ? ' compact' : ''}`} role="note">
      {compact ? null : <b>Kam se zpráva pošle</b>}
      <p>
        {what ? <>{what} </> : null}
        Prostředí: <b>{env.label}</b>. Režim odesílání:{' '}
        <Badge tone={mode.tone}>{SEND_MODE_LABEL[me.sendMode]}</Badge> {mode.text}
      </p>
    </div>
  );
}
